<template>
  <v-slide-y-reverse-transition
    v-if="fullCashControl"
  >
    <v-chip-group
      v-show="isCash"
      v-model="selected"
      v-resize="setInnerHeight"
      :column="innerHeight >= 640"
      mandatory
      center-active
      active-class="primary font-weight-medium"
      class="mx-2"
    >
      <v-chip
        v-for="(n, i) in monies.length"
        :key="n"
        :ripple="false"
        :class="{'secondary': completed[i]}"
      >
        <span class="h-chip__content">
          {{ monies[i] | money }}
        </span>
      </v-chip>
    </v-chip-group>
  </v-slide-y-reverse-transition>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'

  export default {
    mixins: [
      Currenciable,
    ],

    data: () => ({
      innerHeight: 0,
    }),

    computed: {
      ...mapState('cashControl/form', [
        'selectedMoney',
      ]),
      ...mapGetters('cashControl/form', [
        'fullCashControl',
        'isCash',
        'monies',
        'cashTill',
      ]),
      selected: {
        get () {
          return this.selectedMoney
        },
        set (v) {
          this.$store.commit('cashControl/form/selectedMoney', v)
        },
      },
      completed () {
        return Object.values(this.cashTill).map(v => v.greaterThan(0))
      },
    },

    mounted () {
      this.setInnerHeight()
    },

    methods: {
      setInnerHeight () {
        this.innerHeight = window.innerHeight
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-chip__content {
    width: 2em;
    text-align: center;
  }
</style>
